import React from 'react';
import { motion } from 'framer-motion';
import { Battery, Dumbbell, CalendarCheck, Target, Sparkles } from 'lucide-react';
export function Results() {
  const results = [{
    icon: Battery,
    text: 'Más energía todos los días'
  }, {
    icon: Dumbbell,
    text: 'Un cuerpo más firme'
  }, {
    icon: CalendarCheck,
    text: 'Crear el hábito del entrenamiento'
  }, {
    icon: Target,
    text: 'Más disciplina'
  }, {
    icon: Sparkles,
    text: 'Más confianza personal'
  }];
  return <section className="py-20 bg-rose-50" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-188">
          <span className="text-rose-600 font-bold tracking-wider uppercase text-sm" data-id="element-189">
            Transformación
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mt-2 mb-4" data-id="element-190">
            Lo que podés lograr en 30 días
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-191">
            Pequeñas acciones diarias generan grandes cambios. Esto es lo que
            vas a experimentar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-192">
          {results.map((result, index) => <motion.div key={index} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow border border-rose-100 flex flex-col items-center text-center group" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-193">
              <div className="w-16 h-16 rounded-full bg-rose-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-194">
                <result.icon className="w-8 h-8 text-rose-500" data-id="element-195" />
              </div>
              <h3 className="text-xl font-bold text-gray-900" data-id="element-196">{result.text}</h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}